function formatPrice(rawPrice: number): string {
    return `${rawPrice.toFixed(2)}`
}

export default formatPrice